// actionType:
// -- detail
// -- add
// -- remove
// -- purchase

export default (props, inject) => {
  const yandexCommerce = function (actionType, products = [], additionalInformation = {}) {
    // Инициализация dataLayer
    window.dataLayer = window.dataLayer || [];

    // Трансформация товаров
    const formatProduct = _getProducts(products);

    const ecommerce = {
      currencyCode: 'RUB',
      [actionType]: {
        products: formatProduct,
      },
    };
    if (actionType === 'purchase') {
      ecommerce[actionType].actionField = {
        id: additionalInformation?.actionFieldId,
        goal_id: 291053344,
      };
    }

    window.dataLayer.push({
      ecommerce: ecommerce,
    });
  };

  return inject('yandexCommerce', yandexCommerce);
};

const _getProducts = (products = []) => products.map((product) => {
  if (!product) {
    return {};
  }

  return {
    id: product.id,
    name: product.name,
    category: product?.category?.name || product?.category,
    price: product.price || product.newPrice,
    quantity: product.quantity,
  };
});
